import {DEFAULT_REDIRECT_URI} from "../constants";
import {getBuildInfo} from "./APIUtils";
import moment from "moment/moment";

export const generateDeviceId = () => {
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substr(2, 8);
  const uniqueSuffix = Math.random().toString(36).substr(2, 4);
  return 'id-' + timestamp + '-' + randomPart + '-' + uniqueSuffix;
};

export const getDeviceInfo = async (query) => {
  const redirectParam = query?.get('redirect');
  const redirect = redirectParam ?? DEFAULT_REDIRECT_URI;
  const pathArr = redirect.split('/');
  const domain =
    pathArr.length > 3 ? `${pathArr[0]}//${pathArr[2]}` : redirect;
  const appInfo = await getBuildInfo(domain);
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId || deviceId === "null") {
    deviceId = generateDeviceId();
    localStorage.setItem('deviceId', deviceId);
  }
  const appVersion = appInfo?.commitHash &&
    `${moment(appInfo.buildTime, 'ddd MMM DD HH:mm:ss [UTC] YYYY')
      .add(7, 'hours')
      .format('DD/MM/YYYY HH:mm')} (${appInfo.commitHash})`

  return {deviceId, appVersion, deviceName: navigator.userAgent};
}
